// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacmydataIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacmydataIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacmydataIconOutlined = function DrrpDacmydataIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacmydataIconOutlinedSvg
  }));
};

DrrpDacmydataIconOutlined.displayName = 'DrrpDacmydataIconOutlined';
export default React.forwardRef(DrrpDacmydataIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacmydataIconOutlined.js
// module id = 2511
// module chunks = 0